// AUTO-GENERATED. DO NOT EDIT.
/* eslint-disable @stylistic/quote-props */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Translation } from '@helpwave/internationalization'
import { TranslationGen } from '@helpwave/internationalization'

export const hightideTranslationLocales = ['de-DE', 'en-US'] as const

export type HightideTranslationLocales = typeof hightideTranslationLocales[number]

export type HightideTranslationEntries = {
  'add': string,
  'addFilter': string,
  'addSorting': string,
  'addTime': string,
  'after': string,
  'age': string,
  'all': string,
  'apply': string,
  'back': string,
  'before': string,
  'between': string,
  'cancel': string,
  'carousel': string,
  'caseSensitive': string,
  'change': string,
  'changeColumnDisplay': string,
  'changePinning': string,
  'changeSelection': string,
  'changeVisibility': string,
  'chooseLanguage': string,
  'chooseSlide': string,
  'chooseTheme': string,
  'clear': string,
  'clearValue': string,
  'click': string,
  'clickToCopy': string,
  'clickToSelect': string,
  'close': string,
  'closeDialog': string,
  'columnPicker': string,
  'columnPickerDescription': string,
  'columns': string,
  'confirm': string,
  'contains': string,
  'copied': string,
  'copy': string,
  'create': string,
  'date': string,
  'dayPeriod': string,
  'decline': string,
  'decreaseSortingPriority': string,
  'decreaseValue': string,
  'delete': string,
  'discard': string,
  'discardChanges': string,
  'done': string,
  'edit': string,
  'editFilter': string,
  'endDate': string,
  'endsWith': string,
  'enterText': string,
  'entriesPerPage': string,
  'entryDate': string,
  'equals': string,
  'error': string,
  'errorOccurred': string,
  'exit': string,
  'fieldRequiredError': string,
  'filter': string,
  'filterNonWhitespace': string,
  'filterNotUndefined': string,
  'filterOptions': string,
  'filterUndefined': string,
  'first': string,
  'goodToSeeYou': string,
  'greaterThan': string,
  'greaterThanOrEqual': string,
  'hideAllColumns': string,
  'hideColumn': string,
  'identifier': string,
  'increaseSortingPriority': string,
  'increaseValue': string,
  'invalidEmail': string,
  'invalidEmailError': string,
  'isFalse': string,
  'isNotUndefined': string,
  'isTrue': string,
  'isUndefined': string,
  'language': string,
  'last': string,
  'less': string,
  'lessThan': string,
  'lessThanOrEqual': string,
  'loading': string,
  'locale': string,
  'max': string,
  'maxLengthError': string,
  'menu': string,
  'min': string,
  'minLengthError': string,
  'more': string,
  'moveDown': string,
  'moveUp': string,
  'name': string,
  'next': string,
  'no': string,
  'noColumn': string,
  'noData': string,
  'none': string,
  'noParameterRequired': string,
  'notBetween': string,
  'notContains': string,
  'notEmpty': string,
  'notEquals': string,
  'nothingFound': string,
  'nResultsFound': (values: { count: number }) => string,
  'of': string,
  'onOrAfter': string,
  'onOrBefore': string,
  'optional': string,
  'outOfRangeNumber': (values: { min: number, max: number }) => string,
  'outOfRangeSelectionItems': (values: { min: number, max: number }) => string,
  'outOfRangeString': (values: { min: number, max: number }) => string,
  'parameter': string,
  'pauseTrace': string,
  'pinLeft': string,
  'pinned': string,
  'pinRight': string,
  'pinToLeft': string,
  'pinToRight': string,
  'playTrace': string,
  'pleaseWait': string,
  'previous': string,
  'pThemes': (values: { count: number }) => string,
  'rBetween': (values: { value1: string, value2: string }) => string,
  'rContains': (values: { value: string }) => string,
  'remove': string,
  'removeFilter': string,
  'removeProperty': string,
  'rEndsWith': (values: { value: string }) => string,
  'rEquals': (values: { value: string }) => string,
  'required': string,
  'reset': string,
  'rGreaterThan': (values: { value: string }) => string,
  'rGreaterThanOrEqual': (values: { value: string }) => string,
  'rLessThan': (values: { value: string }) => string,
  'rLessThanOrEqual': (values: { value: string }) => string,
  'rNotBetween': (values: { value1: string, value2: string }) => string,
  'rNotContains': (values: { value: string }) => string,
  'rNotEquals': (values: { value: string }) => string,
  'rSortingOrderAfter': (values: { otherSortings: number }) => string,
  'rStartsWith': (values: { value: string }) => string,
  'save': string,
  'saved': string,
  'sDateTimeSelect': (values: { datetimeMode: string }) => string,
  'search': string,
  'searchResults': string,
  'select': string,
  'selection': string,
  'selectOption': string,
  'sGender': (values: { gender: string }) => string,
  'show': string,
  'showAllColumns': string,
  'showColumn': string,
  'showLess': string,
  'showMore': string,
  'showSlide': (values: { index: number }) => string,
  'slide': string,
  'slideNavigation': string,
  'slideOf': (values: { index: number, length: number }) => string,
  'sortAsc': string,
  'sortDesc': string,
  'sorting': string,
  'speed': string,
  'sSortingState': (values: { sortDirection: string }) => string,
  'startDate': string,
  'startsWith': string,
  'sThemeMode': (values: { theme: string }) => string,
  'street': string,
  'submit': string,
  'success': string,
  'tag': string,
  'tags': string,
  'text': string,
  'time.ago': string,
  'time.agoDays': (values: { days: number }) => string,
  'time.april': string,
  'time.august': string,
  'time.century': (values: { count: number }) => string,
  'time.day': (values: { count: number }) => string,
  'time.decade': (values: { count: number }) => string,
  'time.december': string,
  'time.february': string,
  'time.hour': (values: { count: number }) => string,
  'time.in': string,
  'time.inDays': (values: { days: number }) => string,
  'time.january': string,
  'time.july': string,
  'time.june': string,
  'time.march': string,
  'time.may': string,
  'time.microsecond': (values: { count: number }) => string,
  'time.millisecond': (values: { count: number }) => string,
  'time.minute': (values: { count: number }) => string,
  'time.month': (values: { count: number }) => string,
  'time.nanosecond': (values: { count: number }) => string,
  'time.nextMonth': string,
  'time.november': string,
  'time.october': string,
  'time.previousMonth': string,
  'time.second': (values: { count: number }) => string,
  'time.september': string,
  'time.sMonthName': (values: { month: string }) => string,
  'time.today': string,
  'time.tomorrow': string,
  'time.year': (values: { count: number }) => string,
  'time.yesterday': string,
  'tooFewSelectionItems': (values: { min: number }) => string,
  'tooLong': (values: { max: number }) => string,
  'tooManySelectionItems': (values: { max: number }) => string,
  'tooShort': (values: { min: number }) => string,
  'unknown': string,
  'unpin': string,
  'unsavedChanges': string,
  'unsavedChangesSaveQuestion': string,
  'update': string,
  'value': string,
  'welcome': string,
  'withoutTime': string,
  'yes': string,
}

export const hightideTranslation: Translation<HightideTranslationLocales, Partial<HightideTranslationEntries>> = {
  'de-DE': {
    'add': `Hinzufügen`,
    'addFilter': `Filter hinzufügen`,
    'addSorting': `Sortierung hinzufügen`,
    'addTime': `Uhrzeit hinzufügen`,
    'after': `Nach`,
    'age': `Alter`,
    'all': `Alle`,
    'apply': `Anwenden`,
    'back': `Zurück`,
    'before': `Vor`,
    'between': `Zwischen`,
    'cancel': `Abbrechen`,
    'carousel': `Karussell`,
    'caseSensitive': `Groß-/Klein beachten`,
    'change': `Ändern`,
    'changeColumnDisplay': `Spaltenanzeige ändern`,
    'changePinning': `Anheften ändern`,
    'changeSelection': `Auswahl ändern`,
    'changeVisibility': `Sichtbarkeit ändern`,
    'chooseLanguage': `Wähle deine bevorzugte Sprache`,
    'chooseSlide': `Wähle die angezeigte Slide aus`,
    'chooseTheme': `Wähle dein bevorzugtes Farbschema.`,
    'clear': `Löschen`,
    'clearValue': `Wert löschen`,
    'click': `Klicken`,
    'clickToCopy': `Zum kopieren klicken`,
    'clickToSelect': `Zum Auswählen drücken`,
    'close': `Schließen`,
    'closeDialog': `Dialog schließen`,
    'columnPicker': `Spaltenauswahl`,
    'columnPickerDescription': `Spalten neu anordnen und ein- oder ausblenden`,
    'columns': `Spalten`,
    'confirm': `Bestätigen`,
    'contains': `Enthält`,
    'copied': `Kopiert`,
    'copy': `Kopieren`,
    'create': `Erstellen`,
    'date': `Datum`,
    'dayPeriod': `AM/PM`,
    'decline': `Ablehnen`,
    'decreaseSortingPriority': `Sortierpriorität verringern`,
    'decreaseValue': `Wert verringern`,
    'delete': `Löschen`,
    'discard': `Verwerfen`,
    'discardChanges': `Änderungen Verwerfen`,
    'done': `Fertig`,
    'edit': `Bearbeiten`,
    'editFilter': `Filter bearbeiten`,
    'endDate': `Ende`,
    'endsWith': `Endet mit`,
    'enterText': `Text hier eingeben`,
    'entriesPerPage': `Einträge pro Seite`,
    'entryDate': `Eintragsdatum`,
    'equals': `Gleich`,
    'error': `Fehler`,
    'errorOccurred': `Ein Fehler ist aufgetreten`,
    'exit': `Beenden`,
    'fieldRequiredError': `Dieses Feld ist erforderlich.`,
    'filter': `Filter`,
    'filterNonWhitespace': `Nicht leer`,
    'filterNotUndefined': `Definiert`,
    'filterOptions': `Optionen filtern`,
    'filterUndefined': `Undefiniert`,
    'first': `Erste`,
    'goodToSeeYou': `Schön dich zu sehen`,
    'greaterThan': `Größer als`,
    'greaterThanOrEqual': `Größer oder gleich`,
    'hideAllColumns': `Alle Spalten ausblenden`,
    'hideColumn': `Spalte ausblenden`,
    'identifier': `Identifikator`,
    'increaseSortingPriority': `Sortierpriorität erhöhen`,
    'increaseValue': `Wert erhöhen`,
    'invalidEmail': `Die E-Mail ist ungültig.`,
    'invalidEmailError': `Bitte geben Sie eine gültige E-Mail-Adresse ein.`,
    'isFalse': `Ist falsch`,
    'isNotUndefined': `Ist definiert`,
    'isTrue': `Ist wahr`,
    'isUndefined': `Ist undefiniert`,
    'language': `Sprache`,
    'last': `Letzte`,
    'less': `Weniger`,
    'lessThan': `Kleiner als`,
    'lessThanOrEqual': `Kleiner oder gleich`,
    'loading': `Lädt`,
    'locale': `Locale`,
    'max': `Max`,
    'maxLengthError': `Maximale Länge überschritten.`,
    'menu': `Menü`,
    'min': `Min`,
    'minLengthError': `Mindestlänge nicht erreicht.`,
    'more': `Mehr`,
    'moveDown': `Nach unten`,
    'moveUp': `Nach oben`,
    'name': `Name`,
    'next': `Weiter`,
    'no': `Nein`,
    'noColumn': `Keine Spalte`,
    'noData': `Keine Daten`,
    'none': `Nichts`,
    'noParameterRequired': `Kein Parameter erforderlich`,
    'notBetween': `Nicht zwischen`,
    'notContains': `Enthält nicht`,
    'notEmpty': `Das Feld darf nicht leer sein.`,
    'notEquals': `Nicht gleich`,
    'nothingFound': `Nichts gefunden`,
    'nResultsFound': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `${count} Ergebnis gefunden`,
        'other': `${count} Ergebnisse gefunden`,
      })
    },
    'of': `von`,
    'onOrAfter': `Nach oder Gleich`,
    'onOrBefore': `Vor oder Gleich`,
    'optional': `Optional`,
    'outOfRangeNumber': ({ min, max }): string => {
      return `Der Wert muss zwischen ${min} und ${max} liegen.`
    },
    'outOfRangeSelectionItems': ({ min, max }): string => {
      return `Es müssen zwischen ${min} und ${max} Elemente ausgewählt werden.`
    },
    'outOfRangeString': ({ min, max }): string => {
      return `Der Wert muss zwischen ${min} und ${max} Zeichen lang sein.`
    },
    'parameter': `Parameter`,
    'pauseTrace': `Trace pausieren`,
    'pinLeft': `Links anheften`,
    'pinned': `Angeheftet`,
    'pinRight': `Rechts anheften`,
    'pinToLeft': `Links anheften`,
    'pinToRight': `Rechts anheften`,
    'playTrace': `Trace abspielen`,
    'pleaseWait': `Bitte warten...`,
    'previous': `Vorherige`,
    'pThemes': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Farbschema`,
        'other': `Farbschemas`,
      })
    },
    'rBetween': ({ value1, value2 }): string => {
      return `Zwischen ${value1} und ${value2}`
    },
    'rContains': ({ value }): string => {
      return `Enthält ${value}`
    },
    'remove': `Entfernen`,
    'removeFilter': `Filter entfernen`,
    'removeProperty': `Eigenschaft entfernen`,
    'rEndsWith': ({ value }): string => {
      return `Endet mit ${value}`
    },
    'rEquals': ({ value }): string => {
      return `Gleich ${value}`
    },
    'required': `Erforderlich`,
    'reset': `Zurücksetzen`,
    'rGreaterThan': ({ value }): string => {
      return `Größer als ${value}`
    },
    'rGreaterThanOrEqual': ({ value }): string => {
      return `Größer oder gleich ${value}`
    },
    'rLessThan': ({ value }): string => {
      return `Kleiner als ${value}`
    },
    'rLessThanOrEqual': ({ value }): string => {
      return `Kleiner oder gleich ${value}`
    },
    'rNotBetween': ({ value1, value2 }): string => {
      return `Nicht zwischen ${value1} und ${value2}`
    },
    'rNotContains': ({ value }): string => {
      return `Enthält nicht ${value}`
    },
    'rNotEquals': ({ value }): string => {
      return `Nicht gleich ${value}`
    },
    'rSortingOrderAfter': ({ otherSortings }): string => {
      let _out: string = ''
      _out += `Angewendet `
      _out += TranslationGen.resolvePlural(otherSortings, {
        '=0': `als primäre Sortierung`,
        '=1': `nach einer anderen Sortierung`,
        'other': `nach ${otherSortings} anderen Sortierungen`,
      })
      return _out
    },
    'rStartsWith': ({ value }): string => {
      return `Beginnt mit ${value}`
    },
    'save': `Speichern`,
    'saved': `Gespeichert`,
    'sDateTimeSelect': ({ datetimeMode }): string => {
      return TranslationGen.resolveSelect(datetimeMode, {
        'time': `Zeit auswählen`,
        'date': `Datum auswählen`,
        'dateTime': `Datum und Uhrzeit auswählen`,
      })
    },
    'search': `Suche`,
    'searchResults': `Suchergebnisse`,
    'select': `Select`,
    'selection': `Auswahl`,
    'selectOption': `Option auswählen`,
    'sGender': ({ gender }): string => {
      return TranslationGen.resolveSelect(gender, {
        'male': `Männlich`,
        'female': `Weiblich`,
        'other': `Divers`,
      })
    },
    'show': `Anzeigen`,
    'showAllColumns': `Alle Spalten einblenden`,
    'showColumn': `Spalte einblenden`,
    'showLess': `Weniger anzeigen`,
    'showMore': `Mehr anzeigen`,
    'showSlide': ({ index }): string => {
      return `Zeige Slide ${index}`
    },
    'slide': `Slide`,
    'slideNavigation': `Slide Navigation`,
    'slideOf': ({ index, length }): string => {
      return `Slide ${index} von ${length} slides`
    },
    'sortAsc': `ASC`,
    'sortDesc': `DESC`,
    'sorting': `Sortierung`,
    'speed': `Geschwindigkeit`,
    'sSortingState': ({ sortDirection }): string => {
      return TranslationGen.resolveSelect(sortDirection, {
        'asc': `Sortierung (Aktuell Aufsteigend)`,
        'desc': `Sortierung (Aktuell Absteigend)`,
        'other': `Sortierung (Aktuell Keine)`,
      })
    },
    'startDate': `Start`,
    'startsWith': `Beginnt mit`,
    'sThemeMode': ({ theme }): string => {
      return TranslationGen.resolveSelect(theme, {
        'dark': `Dunkel`,
        'light': `Hell`,
        'system': `System`,
      })
    },
    'street': `Straße`,
    'submit': `Abschicken`,
    'success': `Erfolg`,
    'tag': `Tag`,
    'tags': `Tags`,
    'text': `Text`,
    'time.ago': `vor`,
    'time.agoDays': ({ days }): string => {
      return `var ${days} Tagen`
    },
    'time.april': `April`,
    'time.august': `August`,
    'time.century': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Jahrhundert`,
        'other': `Jahrhunderte`,
      })
    },
    'time.day': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Tag`,
        'other': `Tage`,
      })
    },
    'time.decade': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Jahrzehnt`,
        'other': `Jahrzehnte`,
      })
    },
    'time.december': `December`,
    'time.february': `Febuar`,
    'time.hour': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Stunde`,
        'other': `Stunden`,
      })
    },
    'time.in': `in`,
    'time.inDays': ({ days }): string => {
      return `in ${days} Tagen`
    },
    'time.january': `Januar`,
    'time.july': `Juli`,
    'time.june': `Juni`,
    'time.march': `März`,
    'time.may': `Mai`,
    'time.microsecond': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Mikrosekunde`,
        'other': `Mikrosekunden`,
      })
    },
    'time.millisecond': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Millisekunde`,
        'other': `Millisekunden`,
      })
    },
    'time.minute': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Minute`,
        'other': `Minuten`,
      })
    },
    'time.month': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Monat`,
        'other': `Monate`,
      })
    },
    'time.nanosecond': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Nanosekunde`,
        'other': `Nanosekunden`,
      })
    },
    'time.nextMonth': `Nächster Monat`,
    'time.november': `November`,
    'time.october': `October`,
    'time.previousMonth': `Vorheriger Monat`,
    'time.second': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Sekunde`,
        'other': `Sekunden`,
      })
    },
    'time.september': `September`,
    'time.sMonthName': ({ month }): string => {
      return TranslationGen.resolveSelect(month, {
        'january': `Januar`,
        'february': `Februar`,
        'march': `März`,
        'april': `April`,
        'may': `Mai`,
        'june': `Juni`,
        'july': `Juli`,
        'august': `August`,
        'september': `September`,
        'october': `Oktober`,
        'november': `November`,
        'december': `Dezember`,
        'other': `Unbekannter Monat`,
      })
    },
    'time.today': `Heute`,
    'time.tomorrow': `Morgen`,
    'time.year': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Jahr`,
        'other': `Jahre`,
      })
    },
    'time.yesterday': `Gestern`,
    'tooFewSelectionItems': ({ min }): string => {
      return `Es müssen mindestens ${min} Elemente ausgewählt werden.`
    },
    'tooLong': ({ max }): string => {
      return `Der Wert darf höchstens ${max} Zeichen enthalten.`
    },
    'tooManySelectionItems': ({ max }): string => {
      return `Es müssen maximal ${max} Elemente ausgewählt werden.`
    },
    'tooShort': ({ min }): string => {
      return `Der Wert muss mindestens ${min} Zeichen enthalten.`
    },
    'unknown': `Unbekannt`,
    'unpin': `Loslösen`,
    'unsavedChanges': `Ungespeicherte Änderungen`,
    'unsavedChangesSaveQuestion': `Möchtest du die Änderungen speichern?`,
    'update': `Update`,
    'value': `Wert`,
    'welcome': `Willkommen`,
    'withoutTime': `Ohne Uhrzeit`,
    'yes': `Ja`
  },
  'en-US': {
    'add': `Add`,
    'addFilter': `Add filter`,
    'addSorting': `Add sorting`,
    'addTime': `Add Time`,
    'after': `After`,
    'age': `Age`,
    'all': `All`,
    'apply': `Apply`,
    'back': `Back`,
    'before': `Before`,
    'between': `Between`,
    'cancel': `Cancel`,
    'carousel': `Carousel`,
    'caseSensitive': `Case Sensitive`,
    'change': `Change`,
    'changeColumnDisplay': `Change column display`,
    'changePinning': `Change pinning`,
    'changeSelection': `Change selection`,
    'changeVisibility': `Change visibility`,
    'chooseLanguage': `Choose your language`,
    'chooseSlide': `Choose slide to display`,
    'chooseTheme': `Choose your preferred color theme.`,
    'clear': `Clear`,
    'clearValue': `Clear Value`,
    'click': `Click`,
    'clickToCopy': `Click to Copy`,
    'clickToSelect': `Click to select`,
    'close': `Close`,
    'closeDialog': `Close dialog`,
    'columnPicker': `Column Picker`,
    'columnPickerDescription': `Reorder and show or hide columns`,
    'columns': `Columns`,
    'confirm': `Confirm`,
    'contains': `Contains`,
    'copied': `Copied`,
    'copy': `Copy`,
    'create': `Create`,
    'date': `Date`,
    'dayPeriod': `AM/PM`,
    'decline': `Decline`,
    'decreaseSortingPriority': `Decrease sorting priority`,
    'decreaseValue': `Decrease value`,
    'delete': `Delete`,
    'discard': `Discard`,
    'discardChanges': `Discard Changes`,
    'done': `Done`,
    'edit': `Edit`,
    'editFilter': `Edit filter`,
    'endDate': `End`,
    'endsWith': `Ends with`,
    'enterText': `Enter text here`,
    'entriesPerPage': `Entries per page`,
    'entryDate': `Entry Date`,
    'equals': `Equals`,
    'error': `Error`,
    'errorOccurred': `An error occurred`,
    'exit': `Exit`,
    'fieldRequiredError': `This field is required.`,
    'filter': `Filter`,
    'filterNonWhitespace': `Non-whitespace`,
    'filterNotUndefined': `Defined`,
    'filterOptions': `Filter options`,
    'filterUndefined': `Undefined`,
    'first': `First`,
    'goodToSeeYou': `Good to see you`,
    'greaterThan': `Greater than`,
    'greaterThanOrEqual': `Greater than or equal`,
    'hideAllColumns': `Hide all columns`,
    'hideColumn': `Hide column`,
    'identifier': `Identifier`,
    'increaseSortingPriority': `Increase sorting priority`,
    'increaseValue': `Increase value`,
    'invalidEmail': `The email is not valid.`,
    'invalidEmailError': `Please enter a valid email address.`,
    'isFalse': `Is false`,
    'isNotUndefined': `Is defined`,
    'isTrue': `Is true`,
    'isUndefined': `Is undefined`,
    'language': `Language`,
    'last': `Last`,
    'less': `Less`,
    'lessThan': `Less than`,
    'lessThanOrEqual': `Less than or equal`,
    'loading': `Loading`,
    'locale': `Locale`,
    'max': `Max`,
    'maxLengthError': `Maximum length exceeded.`,
    'menu': `Menu`,
    'min': `Min`,
    'minLengthError': `Minimum length not met.`,
    'more': `More`,
    'moveDown': `Move down`,
    'moveUp': `Move up`,
    'name': `Name`,
    'next': `Next`,
    'no': `No`,
    'noColumn': `No column`,
    'noData': `No data`,
    'none': `None`,
    'noParameterRequired': `No parameter required`,
    'notBetween': `Not between`,
    'notContains': `Not contains`,
    'notEmpty': `The field cannot be empty.`,
    'notEquals': `Not equals`,
    'nothingFound': `Nothing found`,
    'nResultsFound': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `${count} result found`,
        'other': `${count} results found`,
      })
    },
    'of': `of`,
    'onOrAfter': `After or Equal`,
    'onOrBefore': `Before or Equal`,
    'optional': `Optional`,
    'outOfRangeNumber': ({ min, max }): string => {
      return `The value must be between ${min} and ${max}.`
    },
    'outOfRangeSelectionItems': ({ min, max }): string => {
      return `Between ${min} and ${max} items must be selected.`
    },
    'outOfRangeString': ({ min, max }): string => {
      return `The value needs to have between ${min} and ${max} characters.`
    },
    'parameter': `Parameter`,
    'pauseTrace': `Pause trace`,
    'pinLeft': `Pin to left`,
    'pinned': `Pinned`,
    'pinRight': `Pin to right`,
    'pinToLeft': `Pin to left`,
    'pinToRight': `Pin to right`,
    'playTrace': `Play trace`,
    'pleaseWait': `Please wait...`,
    'previous': `Previous`,
    'pThemes': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Theme`,
        'other': `Themes`,
      })
    },
    'rBetween': ({ value1, value2 }): string => {
      return `Between ${value1} and ${value2}`
    },
    'rContains': ({ value }): string => {
      return `Contains ${value}`
    },
    'remove': `Remove`,
    'removeFilter': `Remove filter`,
    'removeProperty': `Remove Property`,
    'rEndsWith': ({ value }): string => {
      return `Ends with ${value}`
    },
    'rEquals': ({ value }): string => {
      return `Equals ${value}`
    },
    'required': `Required`,
    'reset': `Reset`,
    'rGreaterThan': ({ value }): string => {
      return `Greater than ${value}`
    },
    'rGreaterThanOrEqual': ({ value }): string => {
      return `Greater than or equal ${value}`
    },
    'rLessThan': ({ value }): string => {
      return `Less than ${value}`
    },
    'rLessThanOrEqual': ({ value }): string => {
      return `Less than or equal ${value}`
    },
    'rNotBetween': ({ value1, value2 }): string => {
      return `Not between ${value1} and ${value2}`
    },
    'rNotContains': ({ value }): string => {
      return `Not contains ${value}`
    },
    'rNotEquals': ({ value }): string => {
      return `Not equals ${value}`
    },
    'rSortingOrderAfter': ({ otherSortings }): string => {
      let _out: string = ''
      _out += `Applied `
      _out += TranslationGen.resolvePlural(otherSortings, {
        '=0': `as the first sorting`,
        '=1': `after ${otherSortings} other sorting`,
        'other': `after ${otherSortings} other sortings`,
      })
      return _out
    },
    'rStartsWith': ({ value }): string => {
      return `Starts with ${value}`
    },
    'save': `Save`,
    'saved': `Saved`,
    'sDateTimeSelect': ({ datetimeMode }): string => {
      return TranslationGen.resolveSelect(datetimeMode, {
        'time': `Select Time`,
        'date': `Select Date`,
        'dateTime': `Select Date and Time`,
      })
    },
    'search': `Search`,
    'searchResults': `Search results`,
    'select': `Select`,
    'selection': `Selection`,
    'selectOption': `Select an option`,
    'sGender': ({ gender }): string => {
      return TranslationGen.resolveSelect(gender, {
        'male': `Male`,
        'female': `Female`,
        'other': `Other`,
      })
    },
    'show': `Show`,
    'showAllColumns': `Show all columns`,
    'showColumn': `Show column`,
    'showLess': `Show less`,
    'showMore': `Show more`,
    'showSlide': ({ index }): string => {
      return `Show Slide ${index}`
    },
    'slide': `Slide`,
    'slideNavigation': `Slide navigation`,
    'slideOf': ({ index, length }): string => {
      return `Slide ${index} of ${length} slides`
    },
    'sortAsc': `ASC`,
    'sortDesc': `DESC`,
    'sorting': `Sorting`,
    'speed': `Speed`,
    'sSortingState': ({ sortDirection }): string => {
      return TranslationGen.resolveSelect(sortDirection, {
        'asc': `Sorting (Currently Ascending)`,
        'desc': `Sorting (Currently Descending)`,
        'other': `Sorting (Currently None)`,
      })
    },
    'startDate': `Start`,
    'startsWith': `Starts with`,
    'sThemeMode': ({ theme }): string => {
      return TranslationGen.resolveSelect(theme, {
        'dark': `Dark`,
        'light': `Light`,
        'system': `System`,
      })
    },
    'street': `Street`,
    'submit': `Submit`,
    'success': `Success`,
    'tag': `Tag`,
    'tags': `Tags`,
    'text': `Text`,
    'time.ago': `ago`,
    'time.agoDays': ({ days }): string => {
      return `days ${days} ago`
    },
    'time.april': `April`,
    'time.august': `August`,
    'time.century': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Century`,
        'other': `Centuries`,
      })
    },
    'time.day': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Day`,
        'other': `Days`,
      })
    },
    'time.decade': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Decade`,
        'other': `Decades`,
      })
    },
    'time.december': `December`,
    'time.february': `Febuary`,
    'time.hour': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Hour`,
        'other': `Hours`,
      })
    },
    'time.in': `in`,
    'time.inDays': ({ days }): string => {
      return `in ${days} days`
    },
    'time.january': `January`,
    'time.july': `July`,
    'time.june': `June`,
    'time.march': `March`,
    'time.may': `May`,
    'time.microsecond': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Microsecond`,
        'other': `Microseconds`,
      })
    },
    'time.millisecond': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Millisecond`,
        'other': `Milliseconds`,
      })
    },
    'time.minute': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Minute`,
        'other': `Minutes`,
      })
    },
    'time.month': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Month`,
        'other': `Months`,
      })
    },
    'time.nanosecond': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Nanosecond`,
        'other': `Nanoseconds`,
      })
    },
    'time.nextMonth': `Next month`,
    'time.november': `November`,
    'time.october': `October`,
    'time.previousMonth': `Previous month`,
    'time.second': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Second`,
        'other': `Seconds`,
      })
    },
    'time.september': `September`,
    'time.sMonthName': ({ month }): string => {
      return TranslationGen.resolveSelect(month, {
        'january': `January`,
        'february': `February`,
        'march': `March`,
        'april': `April`,
        'may': `May`,
        'june': `June`,
        'july': `July`,
        'august': `August`,
        'september': `September`,
        'october': `October`,
        'november': `November`,
        'december': `December`,
        'other': `Unknown Month`,
      })
    },
    'time.today': `Today`,
    'time.tomorrow': `Tomorrow`,
    'time.year': ({ count }): string => {
      return TranslationGen.resolvePlural(count, {
        '=1': `Year`,
        'other': `Years`,
      })
    },
    'time.yesterday': `Yesterday`,
    'tooFewSelectionItems': ({ min }): string => {
      return `Select at least ${min} items.`
    },
    'tooLong': ({ max }): string => {
      return `The value requires less than ${max} characters.`
    },
    'tooManySelectionItems': ({ max }): string => {
      return `Select at most ${max} items.`
    },
    'tooShort': ({ min }): string => {
      return `The value requires at least ${min} characters.`
    },
    'unknown': `Unknown`,
    'unpin': `Unpin`,
    'unsavedChanges': `Unsaved Changes`,
    'unsavedChangesSaveQuestion': `Do you want to save your changes?`,
    'update': `Update`,
    'value': `Value`,
    'welcome': `Welcome`,
    'withoutTime': `Without Time`,
    'yes': `Yes`
  }
}

